import type { TIrrigationPlanData } from '../../types'

export const hasScheduleChanges = (
  initial: TIrrigationPlanData[],
  current: TIrrigationPlanData[],
): boolean => {
  const currentByEmitterType: Record<string, TIrrigationPlanData> = {}

  current.forEach((e) => {
    currentByEmitterType[e.emitterType] = e
  })

  return initial.some((emitter) => {
    const currentEmitter = currentByEmitterType[emitter.emitterType]

    if (!currentEmitter) return true

    return Object.entries(emitter.zones).some(([zoneId, zone]) => {
      const currentZone = currentEmitter.zones[zoneId]

      if (!currentZone) return true

      if (zone.dailyEvents.length !== currentZone.dailyEvents.length) return true

      const currentByDate: Record<string, number> = {}

      currentZone.dailyEvents.forEach((e) => {
        currentByDate[e.date] = e.duration
      })

      return zone.dailyEvents.some((event) => event.duration !== currentByDate[event.date])
    })
  })
}
